import { ReactNode } from 'react';
import { Card as MuiCard, CardHeader, CardContent, CardActions, SxProps, Theme } from '@mui/material';

interface CardProps {
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  headerActions?: ReactNode;
  sx?: SxProps<Theme>;
}

export default function Card({ title, children, footer, headerActions, sx }: CardProps) {
  return (
    <MuiCard 
      sx={{ 
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        minHeight: 0,
        ...sx
      }}
    >
      <CardHeader 
        title={title}
        action={headerActions}
        sx={{ flexShrink: 0 }}
      />
      
      <CardContent 
        sx={{ 
          flex: 1,
          overflowY: 'auto',
          minHeight: 0,
          p: 2,
          '&:last-child': {
            paddingBottom: 2
          }
        }}
      >
        {children}
      </CardContent>
      
      {footer && (
        <CardActions sx={{ flexShrink: 0, p: 2 }}>
          {footer}
        </CardActions>
      )}
    </MuiCard>
  );
}
